import React from "react";
import "./ConfirmationPopup.css";

const ConfirmationPopup = ({ show, message, onConfirm }) => {
    if (!show) return null;

    return (
        <div className="confirmation-overlay">
            <div className="confirmation-popup">
                <p>{message}</p>
                <button onClick={onConfirm} className="confirm-btn">OK</button>
            </div>
        </div>
    );
};

export default ConfirmationPopup;
